var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsEnvironmentalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000164490219650361336070000003678172287849590179_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,51.5C4.4,41.4,2.7,23.3,12.8,11s28.3-14,40.5-3.8s14,28.3,3.8,40.5c-0.3,0.4-0.7,0.8-1,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,46.6c7.5-2.3,15.4-3.4,23.2-3.4C43,43,50.9,43.9,58.4,46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,15.5h-1c-7.9,0.2-15.8-0.7-23.4-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,12.2c-2.7,0.8-5.4,1.5-8.1,2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 29.5,
    y1: 29.4,
    x2: 6.2,
    y2: 29.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,54.8c3.3-4.8,5.5-14.5,5.3-25.6c0-3.5-1-11.2-1-11.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6,0.6c-5.8,0.1-10.3,13-10.1,28.9c0.1,10,2.1,18.9,5,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,13.5c-0.4-2-2.1-4.8-6.6-8.6c-2,5.4-2.1,8.7-1.4,10.7c0.7,2.1,2.9,3.2,5,2.6l0,0 C46.1,17.7,47.5,15.6,47,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.1,34.6c1-1,1.7-2.1,2.2-3.4c0.9-2.1,1.5-4.4,1.8-6.6c-5.7,1.1-8.5,2.7-9.9,4.2c-0.6,0.6-0.9,1.4-1,2.3 c-0.1,1.3,0.4,2.5,1.3,3.4l0,0C52,35.9,54.5,36,56.1,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.7,27c-1.4-1.5-4.3-3.1-10-4c0.3,1.5,0.7,3,1.1,4.5c0.5,2,1.6,3.9,3.1,5.4c1.7,1.4,4.1,1.3,5.6-0.3l0,0 c1.4-1.4,1.6-3.6,0.5-5.2C40.9,27.3,40.8,27.2,40.7,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,55.7c1.1-0.2,2.2-0.5,3.2-0.9c3.3-1.3,6.5-2.7,9.6-4.3c1.6-0.9,4.4-2,6.4-1.6c0.3,0.1,0.6,0.2,0.8,0.3 c0,0,3.2,1.8,2,2.7c-6.6,5.1-13.6,9.6-21,13.5c-0.9,0.5-1.9,1-2.9,1.3L21.4,66c-0.5,0-1,0.1-1.4,0.5l-3.5,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,58.7l5.5-4.9c1.3-1.1,2.8-1.9,4.4-2.3c1.1-0.3,2.2-0.4,3.3-0.2l0.6,0.1c0.9,0.2,1.8,0.4,2.8,0.6 c2,0.6,4,1.1,6.1,1.4c1.6,0.3,3.3,0.4,4.9,0.5l0,0c1.6,0.1,2.9,1.4,2.8,3.1c0,0,0,0,0,0.1l0,0c-0.1,1.6-1.4,2.9-3.1,2.8 c0,0,0,0-0.1,0l-9.7-0.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsEnvironmentalIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-EnvironmentalIcon.c2e5476411d475325fa83b6accc4b288.svg";
export { ForwardRef as ReactComponent };